import {KTIcon} from '../../../../_metronic/helpers'
const RefundsModalHeader = ({
  setOpenRefundsModal
}) => {  
  return (
    <div className='modal-header'>
      <h2 className='fw-bolder'>New Cancellation Request Form</h2>

      <div
        className='btn btn-icon btn-sm btn-active-icon-primary'
        data-kt-users-modal-action='close'
        onClick={() =>  {
          setOpenRefundsModal(false)
        }}
        style={{cursor: 'pointer'}}
      >
        <KTIcon iconName='cross' className='fs-1' />
      </div>
    </div>
  )
}

export {RefundsModalHeader}
